import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { LoadingIndicatorService } from "../../services/loading-indicator.service";

@Component({
  selector: "hydrao-global-loading-spinner",
  templateUrl: "./global-loading-spinner.component.html",
  styleUrls: ["./global-loading-spinner.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule],
})
export class GlobalLoadingSpinnerComponent {
  private loadingIndicatorService: LoadingIndicatorService = inject(
    LoadingIndicatorService
  );

  public loading: boolean = false;

  constructor() {
    this.loadingIndicatorService.onLoadingChanged.subscribe(
      (loading) => (this.loading = loading)
    );
  }
}
